import { useState } from "react";
import { toast } from "sonner";
import { IdCard } from "lucide-react";
import { Switch } from "./ui/switch";
import { api } from "../lib/api";

export const PortalIdLoginCard = ({ settings }) => {
  const [on, setOn] = useState(!!settings?.portal_saudi_id_only);
  const toggle = async (v) => {
    if (v && !window.confirm("تنبيه: أي شخص يعرف رقم هوية موظف سعودي سيدخل حسابه مباشرة بدون كلمة مرور. هل تريد التفعيل؟")) return;
    setOn(v);
    try { await api.updateSettings({ portal_saudi_id_only: v }); toast.success(v ? "تم تفعيل الدخول برقم الهوية" : "تم إيقاف الدخول برقم الهوية"); }
    catch { setOn(!v); toast.error("تعذّر الحفظ"); }
  };
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/40 p-3 flex items-center justify-between gap-3 sm:col-span-2" data-testid="portal-id-login-card">
      <div className="flex items-start gap-2">
        <IdCard className="h-4 w-4 mt-0.5 text-amber-600" />
        <div><p className="text-sm font-semibold">دخول الموظفين السعوديين برقم الهوية فقط</p>
          <p className="text-xs text-slate-500">رقم هوية يبدأ بـ 1 يدخل التطبيق مباشرة بدون كلمة مرور (للموظفين النشطين فقط)</p></div>
      </div>
      <Switch data-testid="portal-id-login-switch" checked={on} onCheckedChange={toggle} className="data-[state=checked]:bg-amber-600" />
    </div>
  );
};
